// extracted by mini-css-extract-plugin
export default {"find":"Find_find__Q4JUE","heading":"Find_heading__SRkvm","text_bg":"Find_text_bg__A9+4E","slider":"Find_slider__4ypRT","card":"Find_card__IV9X4"};